<template>
    <div ref="complete_pay_new_wrap" style="background-color: #fffc; backdrop-filter: blur(100px); display: flex; flex-direction: column;">
        <MercenaryHeader :isBlur="true" :back-title="'닫기'" :close-action="() => { $GlobalStore.closeModalAll() }"></MercenaryHeader>
        <div style="flex: 1;">
            <div style="margin-top: 80px; text-align: center;">
                <img style="width: 40px;" :src="require('@/assets/img/cert_complete.png')" alt="">
                <div style="font-weight: 500;line-height: 24px; margin-top: 12px;">결제완료</div>
                <div style="font-size: 24px;font-weight: 700;line-height: 34px; color: var(--color-main);">{{ payMethodObj.amt | comma }}원</div>
            </div>
            <div style="padding: 0 12px; margin-top: 16px;">
                <div style="padding: 16px 12px; background-color: #fff; border-radius: 12px; border: 1px solid #ededed;">
                    <div style="display: flex; justify-content: space-between; font-size: 14px;font-weight: 500; padding-bottom: 12px; border-bottom: 1px solid #ededed;">
                        <div style="color: #808080; line-height: 24px;">결제수단</div>
                        <div style="line-height: 24px;"></div>
                    </div>
                    <div style="display: flex; justify-content: space-between; font-size: 14px;font-weight: 500; padding: 12px 0; border-bottom: 1px solid #ededed;">
                        <div style="color: #808080; line-height: 24px;">결제일자</div>
                        <div style="line-height: 24px;">{{ payMethodObj.pay_info.pay_date.replace('.000', '') }}</div>
                    </div>
                    <div style="display: flex; justify-content: space-between; font-size: 14px;font-weight: 500; padding-top: 12px;">
                        <div style="color: #808080; line-height: 24px;">결제정보</div>
                        <div style="line-height: 24px;">{{ payMethodObj.goods_name }}</div>
                    </div>
                </div>
            </div>
        </div>
        <div style="height: 93px; margin-top: 12px; padding: 0 20px;" v-if="isShowSoccerHowText">
            <div style="display: flex; flex-direction: column; align-items: center; margin-bottom: 12px;">
                <img style="width: 56px;" :src="require('@/assets/img/soccerhow_text.png')" alt="">
                <div style="font-weight: 500; font-size: 10px; line-height: 12px; margin-top: 4px; color: #606060;">사커하우 유소년 가족 인증 서비스</div>
            </div>
        </div>
        <CommonPopupFrame v-if="isShowPopup" :isBlur="true" background="#fffc" :changeBottom="0" :changeHeight="100" :isOpen="isShowCompletePopup" :closeCompleteAction="closeCompletePopup">
            <div>
                <div @click="closeCompletePopup" style="display: inline-block; padding: 16px 20px; font-weight: 700; line-height: 24px;">닫기</div>
                <div style="text-align: center; margin-top: 120px;">
                    <div v-if="sendStep === 2" style="font-weight: 700; font-size: 20px; line-height: 32px; margin-bottom: 40px;">좋은 결과 있길 바래요!</div>
                    <div>
                        <div>
                            <img style="width: 80px;" :src="$resourcePath + selectedTeam.image_path" alt="">
                        </div>
                        <div style="font-size: 12px; font-weight: 700; line-height: 24px; color: #b5aaa3;">{{ selectedTeam.name }}</div>
                    </div>
                    <div style="margin-top: 40px;">
                        <div v-if="sendStep === 1" style="font-weight: 500; line-height: 32px; font-size: 20px;"><span style="font-weight: 700;">{{ selectedTeam.name }}</span>에<br>다이렉트 요청서를 전달중입니다...</div>
                        <div v-else-if="sendStep === 2" style="font-weight: 500; line-height: 32px; font-size: 20px;"><span style="font-weight: 700;">{{ selectedTeam.name }}</span>에<br>다이렉트 요청서를 전달했고<br>요청서가 공개됐습니다!</div>
                    </div>
                    <div style="margin-top: 40px; padding: 0 12px;">
                        <ProgressBar v-if="sendStep === 1" :hideProgressBar="hideProgressBar" :isStart="isStart"></ProgressBar>
                    </div>
                    <div style="margin-top: 40px;display:flex; justify-content: center; gap:10px;">
                        <div @click="sendOtherTeam" v-if="sendStep === 2" style="width: 150px; font-weight: 700; font-size: 14px; line-height: 56px; text-align: center; height: 56px; border-radius: 50px; background-color: #fff;"><img :src="require('@/assets/img/other_team_send.png')" style="width:12px; margin-right:5px;">다른 팀에도 보내기</div>
                        <div @click="showRequestReportDetail" v-if="sendStep === 2" style="width: 180px; font-weight: 700; font-size: 14px; line-height: 56px; color: var(--color-main); text-align: center; height: 56px; border-radius: 50px; background-color: #210f03;">요청서 리포트로 이동하기</div>
                    </div>
                </div>
            </div>
        </CommonPopupFrame>
    </div>
</template>

<script>
import MercenaryHeader from '@/components/common/MercenaryHeader'
import CommonPopupFrame from '@/components/modal/my/CommonPopupFrame'
import ProgressBar from '@/components/soccerhowmain/ProgressBar';
// import { CARD_CODE_NAME } from "../../Constants";

export default {
    name: 'CompletePay',
    props: {
        payMethodObj: {
            type: Object,
            default: () => { }
        },
        completeAction: {
            type: Function,
            default: () => { }
        },
        isShowPopup: {
            type: Boolean,
            default: false
        },
        selectedTeam: {
            type: Object,
            default: () => { }
        },
        soccerhowIdx: {
            type: [Number, String],
            default: -1
        }
    },
    components: { MercenaryHeader, CommonPopupFrame, ProgressBar },
    data() {
        return {
            payMethod: null,
            isShowCompletePopup: false,
            sendStep: 1,
            isStart: false,
            isShowSoccerHowText : false,
        }
    },
    methods: {
        sendOtherTeam(){
            this.$GlobalStore.addModal('MakeRequestJoinFormPopup', {soccerhowIdx : this.soccerhowIdx, isFromReportList: true})
        },
        closeCompletePopup() {
            this.isShowCompletePopup = false
            this.isStart = false
            this.sendStep = 1
        },
        showRequestReportDetail() {
            this.$GlobalStore.addModal('RequestReportDetail', { soccerhowIdx: this.soccerhowIdx })
            this.closeCompletePopup()
        },
        hideProgressBar() {
            this.sendStep = 2
        },
    },
    mounted(){
        this.$refs.complete_pay_new_wrap.parentElement.style.zIndex = 301;
    },
    created() {
        if (this.isShowPopup) {
            setTimeout(() => {
                this.isShowCompletePopup = true
            }, 1000)
            setTimeout(() => {
                this.isStart = true
            }, 1200)
        }

        if(this.$route.path !== '/parent_pay' && (this.$GlobalStore.loginInfo() && this.$GlobalStore.loginInfo().isAdult)){
           this.isShowSoccerHowText = true;
        }

    }
}
</script>

<style scoped></style>